<template>
 <div>
    <Menu></Menu>
    <main>
        <div class="banner-q">
         <div class="container">
            <div class="row">
                <div class="col-md-6 qp">
                    <h1 class="text-q-m">KALLPA cambios</h1>
                    <p class="p-m">KALLPA CAMBIOS es una unidad de negocio <br>de KALLPA SAB que Proveer soluciones eficientes a tus necesidades de cambio de moneda  y/o  Solucionar eficientemente tus necesidades de cambio de moneda</p>
                </div>
                <div class="col-md-6 img-banner">
                  <img src="@/assets/img/img-banner.png" alt="">
                </div>
            </div>
          </div>
        </div>

            <div class="col-lg-12 servicio">
              <div class="sp">
                <h1 class="text-q-m text-center">Servicios que brinda<br>
                  la empresa</h1>
                  <br>
                  <p class="text-center p-m">Kallpa SAB es una sociedad anónima que se dedica 
                    a la compra/venta de instrumentos financieros (acciones, bonos, papeles comerciales, entre otros) en el mercadode valores peruano e internacional, a la intermedicación
                    de moneda extranjera Soles/Dólares/Euros <br>y a la banca 
                    de inversión en general.</p>
                </div>
            </div>
          <div class="f-mision">
          <div class="container">
            <div class="row mision">
              <div class="col-md-6 m-t">
                <h1 class="text-q-m">Misión</h1>
                <p class="p-m">Creemos en  la transparencia, la  tecnología, 
                  <br>la agilidad, la empatía, la excelencia en el servicio, 
                  la seguridad y la competencia sana,<br> joven, innvadora. </p>
            </div>
              <div class="col-md-6 d-flex justify-content-end">
                <img src="@/assets/img/mision.png" width="306px" height="306px" alt="">
              </div>
            </div>
            </div>
          </div>

            <div class="container">
            <div class="row mision">
              <div class="col-md-6 d-flex">
                <img src="@/assets/img/vision.png" width="306px" height="306px"  alt="">
              </div>
              <div class="col-md-6 m-t justify-content-end">
                <h1 class="text-q-m">Visión</h1>
                <p class="p-m">Ser la plataforma de cambios más competitiva del mercado peruano, en cuanto a precio, velocidad, dinamismo y seguridad.  </p>
            </div>
            </div>
         </div>
      </main>


<footer class=" text-white">
    <div class="container">
        <div class="col-lg-12 footer ">
            <div class="row">
                <div class="col-md-5">
                    <img src="@/assets/img/logo-vertical.png" alt="" width="250">
                     <p>Un servicio de Kallpa Securities S.A.B.</p>
                    <p>RUC: 20492942121</p>
                   
                </div>
                <div class="col-md-4">
                    <h4>Síguenos en:</h4>
                    <a href="https://facebook.com/kallpasablima" target="_blank"><i class="fab fa-facebook-square"></i> @Kallpasablima</a> <br>
                    <a href="https://www.instagram.com/kallpasab/" target="_blank"><i class="fab fa-instagram"></i> @kallpasab</a> <br>
                    <a href="https://twitter.com/KallpaSAB" target="_blank"><i class="fab fa-twitter-square"></i> @KallpaSAB</a> <br>
                    <a href="https://www.linkedin.com/company/kallpa-educa/?viewAsMember=true" target="_blank"><i class="fab fa-linkedin"></i> @KallpaSAB</a>
                </div>
                <div class="col-md-3">
                    <h4 class="cnt">Contáctanos</h4>
                    <ul class="list-footer">
                        <li><i class="fas fa-phone"></i> 630-7500 Anexo 195</li>
                        <li><i class="fas fa-mobile-alt"></i> 940131392</li>
                        <li><i class="fas fa-envelope"></i>clientes@kallpacambios.com</li>
                        <li><i class="fas fa-map-marker-alt"></i>Jr. Monterosa 233 oficina 902,Chacarilla del Estanque, Santiago de Surco.</li>
                        <li>Horario de atención: {{horaInicio}} - {{horaFin}}</li>
                    </ul>
            </div>
            </div>
        </div>
        <hr>
        <div class="col-lg-12 copyright">
            <div class="row d-flex">
                <p class="col-md-8">2021. Kallpa Securities Sociedad Agente de Bolsa // Kallpa Cambios. Todos los derechos reservados. </p>
                <p class="col-md-2"><a :href="urlPoliticasSeguridad" target="_blank" class="poli-term">Políticas de privacidad</a></p>
                <p class="col-md-2"><a :href="urlTerminosCondiciones" target="_blank" class="poli-term">Términos y condiciones</a></p>
            </div>
        </div>
    </div>
</footer>
  <router-link to="/preguntas" target="_blank" class="chat">
    <img style="margin: 11px;" src="@/assets/img/chat.png" width="">
  </router-link>
  </div>
</template>

<script>
import helpers from "@/services/helpers";

import Menu from "./Menu"

export default {
  name: "Information",
  components: {
    Menu,
  },
  data() {
    return {
      urlPoliticasSeguridad: "#",
      urlTerminosCondiciones: "#",
    };
  },
  mounted(){
    auth.listParameters().then(response => {
      this.urlTerminosCondiciones = response.ParametrosGenerales.find(e=>e.Id == "MENS0006").DetalleParametroValor;
      this.urlPoliticasSeguridad = response.ParametrosGenerales.find(e=>e.Id == "MENS0007").DetalleParametroValor;
    });
  },
  methods:{
    
  },
};
</script>


// WEBPACK FOOTER //
// src/layouts/Information.vue